import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import GetHelpHeader from './GetHelpHeader.tsx';
import PopularArticles from './PopularArticles.tsx';
import OtherTopics from './OtherTopics.tsx';
import CurrentItemInfo from './CurrentItemInfo.tsx';

import { type SelectedListing_viewer$key } from './__generated__/SelectedListing_viewer.graphql.ts';

const SelectedListing: FC<{ viewer: SelectedListing_viewer$key }> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment SelectedListing_viewer on Viewer {
                ...CurrentItemInfo_viewer
                getHelpTopics(
                    orderId: $orderId
                    helpType: $helpType
                    isSeller: $isSeller
                    itemId: $itemId
                ) {
                    ...PopularArticles_getHelpTopics
                    ...OtherTopics_getHelpTopics
                }
            }
        `,
        viewerRef
    );

    const helpTopics = viewer.getHelpTopics;

    return (
        <div>
            <GetHelpHeader />
            <CurrentItemInfo viewer={viewer} />
            <PopularArticles getHelpTopics={helpTopics} />
            <OtherTopics getHelpTopics={helpTopics} />
        </div>
    );
};

export default SelectedListing;
